import classNames from 'classnames'
import { NavItem } from 'components/nav/v2/NavItem'
import { ReactNode } from 'react'
import { PropsWithClassName } from 'types'

export interface ExtendedNavSectionItemProps {
  label: ReactNode
  href: string
}

export interface ExtendedNavSectionProps extends PropsWithClassName {
  label: ReactNode
  items: ExtendedNavSectionItemProps[]
}

export function ExtendedNavSection({
  items,
  label,
  className,
}: ExtendedNavSectionProps) {
  return (
    <div className={classNames(className, 'space-y-1')}>
      <p className='ml-2 text-xs font-medium text-cool-600'>{label}</p>
      <nav>
        {items.map(item => (
          <NavItem key={item.href} href={item.href}>
            {item.label}
          </NavItem>
        ))}
      </nav>
    </div>
  )
}
